import React from 'react';
import { SectionCta } from './CtaButton';
import { painPoints } from '../data/content';
export function PainPoints() {
  return <section className="bg-navy px-5 py-16 text-white sm:py-20" aria-labelledby="pain-title" data-id="element-192" data-mp="2lmsqqo33jald">
      <div className="mx-auto max-w-5xl" data-id="element-193" data-mp="26xmpyvom1cbd">
        <h2 id="pain-title" className="text-center text-[30px] font-black leading-tight tracking-tight sm:text-4xl" data-id="element-194" data-mp="2bxiyn8895rx9">
          DOES ANY OF THIS SOUND <span className="text-gold" data-id="element-195" data-mp="1xwol6b6cl0rq">FAMILIAR?</span>
        </h2>

        <ol className="mt-10 grid gap-x-10 md:grid-cols-2" data-id="element-196" data-mp="21z36d1xhocm6">
          {painPoints.map((p, i) => <li key={p.title} className="flex gap-4 border-t border-white/15 py-6" data-id="element-197" data-mp="1nztqy4h3xmj9" data-mpi={i}>
              <span className="text-4xl font-black leading-none text-gold" aria-hidden="true" data-id="element-198" data-mp="1syn4fwwe9djf">{i + 1}</span>
              <div data-id="element-199" data-mp="3idl59hadsul1">
                <h3 className="text-[18px] font-extrabold uppercase leading-snug" data-id="element-200" data-mp="3idbg1vx5urge">{p.title}</h3>
                <p className="mt-2 text-[16px] leading-relaxed text-white/75" data-id="element-201" data-mp="3nd7i3pmas8tb">{p.body}</p>
              </div>
            </li>)}
        </ol>

        <p className="mt-8 text-center text-2xl font-black leading-snug sm:text-3xl" data-id="element-202" data-mp="1yyu30znvpd5v">
          That’s why we created the <span className="text-teal-bright" data-id="element-203" data-mp="1tzragep34zes">AAC Clinical Blueprint™</span>.
        </p>
        <SectionCta label="Explore the complete system" dark data-id="element-204" data-mp="27v34skzbwnv6" />
      </div>
    </section>;
}